// Breakpoints
type BreakpointKeys = 'sm' | 'md' | 'lg' | 'xl' | '2xl';
export type Breakpoints = Record<BreakpointKeys, string>;
const breakpoints: Breakpoints = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

// Font Scales
const fontScales = {
  xs: ['1.2rem', '1.9rem'],
  s: ['1.4rem', '2.3rem'],
  base: ['1.6rem', '2.4rem'],
  lg: ['1.8rem', '2.9rem'],
  xl: ['2.4rem', '3.8rem'],
  xl2: ['2.8rem', '4.5rem'],
  xl3: ['3rem', '4.8rem'],
  xl4: ['3.8rem', '5.7rem'],
  xl5: ['6rem', '10.1rem'],
} as const;
export type FontScales = typeof fontScales;

// Font Weights
const fontWeights = {
  extraLight: '300',
  light: '400',
  normal: '500',
  bold: '600',
  extraBold: '700',
} as const;

export type FontWeights = typeof fontWeights;

const textTransforms = {
  uppercase: 'uppercase',
  capitalize: 'capitalize',
  lowercase: 'lowercase',
  none: 'none',
};

// text-align

export type TextTransforms = typeof textTransforms;

const textAligns = {
  center: 'center',
  left: 'left',
  right: 'right',
};

export type TextAligns = typeof textAligns;

// Colors
const colors = {
  white: '#ffffff',
  black: '#000000',
  lightBlack: '#474747',

  gray: '#fafafa',
  graySecondary: '#c7c7c7',
  grayTertiary: '#D3D3D3',
  grayLabel: '#6e6e6e',
  grayDisabled: '#9A9EA3',

  colmarBlue: '#004A99',
  colmarBlueTransparent: 'rgba(0, 74, 153,0.3)',
  colmarBlueSecondaryButton: '#C6D8EC',
  blue: '#48618a',
  blueDark: '#2b5178',
  blueLight: '#d1d7e3',
  blueLightSecondary: '#E5EDF5',
  blueTransparent: 'rgba(0,74,153,.30)',

  colmarRed: '#AA182C',
  colmarRedSecondary: '#960023',
  red: '#c9424b',
  deleteRed: '#f54242',
  deleteRedDark: '#bf0606',
  redTransparent: 'rgba(201, 66, 75, .5)',
  redLight: '#d9534f',

  green: '#47b812',
  greenDark: '#33850d',

  orange: '#ed7b18',

  yellowWarning: '#FFCE31',

  backButtonShadow: 'rgba(99, 99, 99, 0.2) 0 0.4rem 0.8rem 0',

  mainBackground: '#EEEEEE',
  whiteBackground: 'rgba(255, 255, 255, 0.85)',
  blackBackground: '#1B1C1E',
  tableRow: 'rgba(219, 219, 219,.6)',
  tableHead: '#48618a',
  tableGray: '#E2E2E2',

  message: 'rgba(90, 95, 100, 0.1)',
  messageSecondary: ' rgba(0, 74, 153, 0.1)',

  borderColor: '#f0f0f0',
  borderColorDark: '#cfcfcf',
  borderColorLight: '#cecece',
  borderColorDarkSecondary: '#5A5F64',
  borderColorDarken: '#2b2b2a',

  disabled: '#cccccc',
  textDisabled: '#666666',

  restTabBackground: '#E2E2E2',
  restTabText: '#5A5F64',
  tabBorder: '#BFBFBF',
  tabHoverBackground: '#DFE8F2',

  accepted: '#DFFAE6',
  acceptedFont: '#4F7767',
  inProgress: '#FFF5CC',
  inProgressFont: '#B57803',
  inReview: '#DAF3FF',
  inReviewFont: '#086898',
  refused: '#E2CBFF',
  refusedFont: '#500CA4',
  abandoned: '#FFBCBC',
  abandonedFont: '#960023',
  abandonedBackground: '#FFEFF3',
  reactivationBackground: '#FFFCF1',
  reactivationFont: '#966300',
  new: '#006EE3',
  deleted: '#E2E2E2',
  deletedFont: '#5A5F64',
  deleteRequested: '#FFE0CC',
  deleteRequestedFont: '#B54708',

  shadow: 'rgba(66, 68, 90, 1)',

  inherit: 'inherit',
} as const;

export type Colors = typeof colors;

export { breakpoints, fontScales, fontWeights, colors, textTransforms, textAligns };
